export const careerPl = {
  career: {
    profile: {
      page: {
        title: 'Mój profil',
        subtitle: 'To na podstawie tych danych powstają Twoje CV.',
        save: 'Zapisz',
        error_prefix: 'Nie udało się wczytać profilu.',
        completeness: 'Kompletność profilu: {score}%',
      },
      fields: {
        headline: {
          label: 'Nagłówek',
          placeholder: 'np. Starszy Inżynier Backend',
        },
        summary: {
          label: 'Podsumowanie',
          placeholder: 'Krótki opis Twojego doświadczenia zawodowego.',
        },
        location: {
          label: 'Lokalizacja',
          placeholder: 'np. Warszawa, Polska',
        },
        visibility: {
          label: 'Widoczność',
          options: {
            PRIVATE: 'Prywatny — widoczny tylko dla Ciebie',
            FRIENDS: 'Znajomi — wkrótce, obecnie działa jak Prywatny',
            PUBLIC: 'Publiczny — widoczny dla każdego z linkiem',
          },
        },
        contact: {
          title: 'Dane kontaktowe',
          subtitle: 'Widoczne tylko dla Ciebie — nie pojawiają się na publicznym profilu.',
          email: 'Email',
          phone: 'Telefon',
          linkedin: 'LinkedIn',
          website: 'Strona WWW',
        },
        slug: {
          label: 'Adres publicznego profilu',
        },
      },
    },
    publicProfile: {
      page: {
        title: 'Profil',
      },
      not_found: 'Ten profil nie istnieje lub nie jest publiczny.',
      error: 'Nie udało się wczytać tego profilu.',
    },
    experiences: {
      page: {
        title: 'Doświadczenie',
        subtitle: 'Twoja historia zawodowa — na jej podstawie powstają CV.',
        add: 'Dodaj doświadczenie',
        empty: 'Brak wpisów doświadczenia. Dodaj pierwszy.',
        error: 'Nie udało się wczytać Twojego doświadczenia.',
      },
      form: {
        createTitle: 'Dodaj doświadczenie',
        editTitle: 'Edytuj doświadczenie',
        subtitle: 'Opisz stanowisko, jego daty oraz użyte technologie.',
      },
      fields: {
        companyName: 'Firma',
        position: 'Stanowisko',
        employmentType: 'Rodzaj zatrudnienia',
        employmentTypePlaceholder: 'np. full_time, kontrakt, freelance',
        startDate: 'Data rozpoczęcia',
        endDate: 'Data zakończenia',
        isCurrent: 'Obecnie tu pracuję',
        description: 'Opis',
        responsibilities: 'Obowiązki',
        responsibilitiesPlaceholder: 'Dodaj obowiązek i naciśnij Enter',
        technologies: 'Technologie',
        technologiesPlaceholder: 'Wyszukaj lub dodaj technologię',
      },
      deleteConfirm: {
        title: 'Usunąć to doświadczenie?',
        description: 'Ten wpis doświadczenia zostanie trwale usunięty z Twojego profilu.',
      },
    },
    skills: {
      page: {
        title: 'Umiejętności',
        subtitle: 'Oceń swój poziom biegłości w znanych technologiach.',
        add: 'Dodaj umiejętność',
        empty: 'Brak umiejętności. Dodaj pierwszą.',
        error: 'Nie udało się wczytać Twoich umiejętności.',
      },
      form: {
        createTitle: 'Dodaj umiejętność',
        editTitle: 'Edytuj umiejętność',
        subtitle: 'Wybierz technologię i oceń swój poziom biegłości.',
      },
      fields: {
        technology: 'Technologia',
        level: 'Poziom biegłości (1-5)',
        yearsOfExperience: 'Lata doświadczenia',
        yearsOfExperienceShort: '{years} lat',
        startedUsingYear: 'Rok rozpoczęcia',
        isPrimary: 'Umiejętność kluczowa',
      },
      deleteConfirm: {
        title: 'Usunąć tę umiejętność?',
        description: 'Ta umiejętność zostanie trwale usunięta z Twojego profilu.',
      },
    },
    projects: {
      page: {
        title: 'Projekty',
        subtitle: 'Projekty portfolio — opisz je raz, powiąż z dowolnym stanowiskiem.',
        add: 'Dodaj projekt',
        empty: 'Brak projektów. Dodaj pierwszy.',
        error: 'Nie udało się wczytać Twoich projektów.',
      },
      form: {
        createTitle: 'Dodaj projekt',
        editTitle: 'Edytuj projekt',
        subtitle: 'Opisz projekt, następnie opcjonalnie powiąż go z doświadczeniem i technologiami.',
      },
      fields: {
        name: 'Nazwa projektu',
        role: 'Twoja rola',
        description: 'Opis',
        startDate: 'Data rozpoczęcia',
        endDate: 'Data zakończenia',
        isOngoing: 'Ten projekt trwa',
        isAnonymized: 'Zanonimizuj nazwę firmy/klienta',
        anonymizedCompany: 'Zanonimizowana etykieta firmy',
        anonymizedCompanyPlaceholder: 'np. Bank z listy Fortune 500',
        status: 'Status',
        category: 'Kategoria',
        categoryPlaceholder: 'Wybierz kategorię',
        achievements: 'Osiągnięcia',
        achievementsPlaceholder: 'Dodaj osiągnięcie i naciśnij Enter',
        challenges: 'Wyzwania',
        challengesPlaceholder: 'Dodaj wyzwanie i naciśnij Enter',
        clients: 'Klienci',
        clientsPlaceholder: 'Dodaj klienta i naciśnij Enter',
        team: 'Członkowie zespołu',
        teamPlaceholder: 'Dodaj imię i nazwisko współpracownika i naciśnij Enter',
        subProjects: 'Podprojekty',
        subProjectNamePlaceholder: 'Nazwa, np. Strona klienta',
        subProjectUrlPlaceholder: 'URL (opcjonalnie)',
        addSubProject: 'Dodaj podprojekt',
        teamSize: 'Wielkość zespołu',
        durationMonths: 'Czas trwania (miesiące)',
        usersCount: 'Liczba użytkowników',
        budgetRange: 'Zakres budżetu',
        budgetRangePlaceholder: 'np. 50-100 tys. zł',
        links: 'Linki',
        demo: 'URL dema',
        github: 'URL GitHub',
        docs: 'URL dokumentacji',
        visibility: 'Widoczność',
        technologies: 'Technologie',
        linkedExperiences: 'Powiązane doświadczenia',
        noExperiences: 'Dodaj najpierw doświadczenie zawodowe, aby powiązać je z tym projektem.',
      },
      statusOptions: {
        ACTIVE: 'Aktywny',
        STAGING: 'Staging',
        ARCHIVED: 'Zarchiwizowany',
      },
      categoryOptions: {
        DEMO: 'Demo',
        INTERNAL: 'Wewnętrzny',
        PRODUCTION: 'Produkcyjny',
      },
      anonymized: 'Zanonimizowany klient',
      deleteConfirm: {
        title: 'Usunąć ten projekt?',
        description: 'Ten projekt zostanie trwale usunięty z Twojego profilu.',
      },
    },
    education: {
      page: {
        title: 'Wykształcenie',
        subtitle: 'Kierunki i kursy, które ukształtowały Twoje doświadczenie.',
        add: 'Dodaj wykształcenie',
        empty: 'Brak wpisów wykształcenia. Dodaj pierwszy.',
        error: 'Nie udało się wczytać Twojego wykształcenia.',
      },
      form: {
        createTitle: 'Dodaj wykształcenie',
        editTitle: 'Edytuj wykształcenie',
        subtitle: 'Dodaj ukończony kierunek, kurs lub program.',
      },
      fields: {
        institution: 'Uczelnia/Instytucja',
        degree: 'Stopień/Tytuł',
        fieldOfStudy: 'Kierunek studiów',
        startDate: 'Data rozpoczęcia',
        endDate: 'Data zakończenia',
        present: 'Obecnie',
        grade: 'Ocena',
        gradePlaceholder: 'np. 3.8 GPA, z wyróżnieniem',
        description: 'Opis',
      },
      deleteConfirm: {
        title: 'Usunąć ten wpis wykształcenia?',
        description: 'Ten wpis zostanie trwale usunięty z Twojego profilu.',
      },
    },
    certifications: {
      page: {
        title: 'Certyfikaty',
        subtitle: 'Certyfikaty i uprawnienia zawodowe.',
        add: 'Dodaj certyfikat',
        empty: 'Brak certyfikatów. Dodaj pierwszy.',
        error: 'Nie udało się wczytać Twoich certyfikatów.',
      },
      form: {
        createTitle: 'Dodaj certyfikat',
        editTitle: 'Edytuj certyfikat',
        subtitle: 'Dodaj certyfikat i dane poświadczenia.',
      },
      fields: {
        name: 'Nazwa certyfikatu',
        issuingOrganization: 'Organizacja wydająca',
        credentialId: 'ID poświadczenia',
        credentialUrl: 'URL poświadczenia',
        issueDate: 'Data wydania',
        expiryDate: 'Data wygaśnięcia',
      },
      expired: 'Wygasł',
      deleteConfirm: {
        title: 'Usunąć ten certyfikat?',
        description: 'Ten certyfikat zostanie trwale usunięty z Twojego profilu.',
      },
    },
    achievements: {
      page: {
        title: 'Osiągnięcia',
        subtitle: 'Nagrody, publikacje i wystąpienia.',
        add: 'Dodaj osiągnięcie',
        empty: 'Brak osiągnięć. Dodaj pierwsze.',
        error: 'Nie udało się wczytać Twoich osiągnięć.',
      },
      form: {
        createTitle: 'Dodaj osiągnięcie',
        editTitle: 'Edytuj osiągnięcie',
        subtitle: 'Dodaj nagrodę, publikację lub wystąpienie.',
      },
      fields: {
        title: 'Tytuł',
        description: 'Opis',
        date: 'Data',
        category: 'Kategoria',
        categoryPlaceholder: 'Wybierz kategorię',
        url: 'URL',
      },
      categoryOptions: {
        AWARD: 'Nagroda',
        PUBLICATION: 'Publikacja',
        SPEAKING: 'Wystąpienie',
        OTHER: 'Inne',
      },
      deleteConfirm: {
        title: 'Usunąć to osiągnięcie?',
        description: 'To osiągnięcie zostanie trwale usunięte z Twojego profilu.',
      },
    },
    languages: {
      page: {
        title: 'Języki',
        subtitle: 'Języki mówione i pisane z poziomami CEFR.',
        add: 'Dodaj język',
        empty: 'Brak języków. Dodaj pierwszy.',
        error: 'Nie udało się wczytać Twoich języków.',
      },
      form: {
        createTitle: 'Dodaj język',
        editTitle: 'Edytuj język',
        subtitle: 'Dodaj język i poziom biegłości.',
      },
      fields: {
        name: 'Język',
        namePlaceholder: 'np. angielski, polski',
        level: 'Poziom',
        levelPlaceholder: 'Wybierz poziom',
        description: 'Uwagi',
      },
      levelOptions: {
        NATIVE: 'Ojczysty',
        C2: 'C2 — Biegłość',
        C1: 'C1 — Zaawansowany',
        B2: 'B2 — Średnio zaawansowany wyższy',
        B1: 'B1 — Średnio zaawansowany',
        A2: 'A2 — Podstawowy wyższy',
        A1: 'A1 — Podstawowy',
      },
      deleteConfirm: {
        title: 'Usunąć ten język?',
        description: 'Ten język zostanie trwale usunięty z Twojego profilu.',
      },
    },
    cvVersions: {
      page: {
        title: 'Wersje CV',
        subtitle: 'Wyselekcjonowane zestawy Twojego profilu, dopasowane do aplikacji.',
        add: 'Dodaj wersję CV',
        empty: 'Brak wersji CV. Dodaj pierwszą.',
        error: 'Nie udało się wczytać Twoich wersji CV.',
        preview: 'Podgląd',
        generate: 'Wygeneruj PDF',
        download: 'Pobierz PDF',
        generateSuccess: 'PDF wygenerowany — gotowy do pobrania.',
        generateSuccessWatermarked: 'PDF wygenerowany ze znakiem wodnym (plan Free) — gotowy do pobrania.',
        downloadNotGenerated: 'Dla tej wersji CV nie wygenerowano jeszcze pliku PDF.',
      },
      form: {
        createTitle: 'Dodaj wersję CV',
        editTitle: 'Edytuj wersję CV',
        subtitle: 'Wybierz nazwę i szablon, a następnie zaznacz, które sekcje profilu uwzględnić.',
      },
      fields: {
        name: 'Nazwa',
        template: 'Szablon',
        customAccentColor: 'Niestandardowy kolor akcentu',
        fontFamily: 'Czcionka',
        density: 'Odstępy',
        customSummary: 'Niestandardowe podsumowanie (opcjonalnie)',
        customSummaryPlaceholder: 'Nadpisz podsumowanie profilu dla tego CV',
        includeSummary: 'Uwzględnij podsumowanie',
        includePhoto: 'Uwzględnij zdjęcie',
        isDefault: 'Domyślne',
        experiences: 'Doświadczenie',
        noExperiences: 'Brak doświadczenia w Twoim profilu.',
        projects: 'Projekty',
        noProjects: 'Brak projektów w Twoim profilu.',
        skills: 'Umiejętności',
        noSkills: 'Brak umiejętności w Twoim profilu.',
        education: 'Wykształcenie',
        noEducation: 'Brak wpisów wykształcenia w Twoim profilu.',
        certifications: 'Certyfikaty',
        noCertifications: 'Brak certyfikatów w Twoim profilu.',
        achievements: 'Osiągnięcia',
        noAchievements: 'Brak osiągnięć w Twoim profilu.',
        languages: 'Języki',
        noLanguages: 'Brak języków w Twoim profilu.',
      },
      templateOptions: {
        default: 'Domyślny',
        modern: 'Nowoczesny',
        classic: 'Klasyczny',
        minimal: 'Minimalistyczny',
        sidebar: 'Panel boczny',
        timeline: 'Oś czasu',
        compact: 'Kompaktowy (ATS)',
      },
      fontOptions: {
        sans: 'Sans',
        'modern-sans': 'Nowoczesny bezszeryfowy',
        serif: 'Szeryfowy',
        'minimal-sans': 'Minimalistyczny bezszeryfowy',
        mono: 'Maszynowy',
      },
      densityOptions: {
        compact: 'Kompaktowy',
        standard: 'Standardowy',
        spacious: 'Przestronny',
      },
      deleteConfirm: {
        title: 'Usunąć tę wersję CV?',
        description: 'Ta wersja CV zostanie trwale usunięta z Twojego profilu.',
      },
    },
    overview: {
      title: 'Twoja kariera w pigułce',
      subtitle: 'Wszystko, z czego powstają Twoje CV, w jednym miejscu.',
      completeness: 'Siła profilu',
      completenessHint: 'Uzupełnij profil i sekcje, aby osiągnąć 100%.',
      error: 'Nie udało się załadować podsumowania kariery.',
      sections: {
        experiences: 'Doświadczenie',
        projects: 'Projekty',
        skills: 'Umiejętności',
        education: 'Edukacja',
        certifications: 'Certyfikaty',
        achievements: 'Osiągnięcia',
        languages: 'Języki',
        cvVersions: 'Wersje CV',
      },
      suggestions: {
        title: 'Sugerowane kolejne kroki',
        addHeadline: 'Dodaj nagłówek do swojego profilu',
        addExperience: 'Dodaj swoje pierwsze doświadczenie zawodowe',
        addSummary: 'Napisz podsumowanie zawodowe',
        addSkills: 'Dodaj co najmniej 3 umiejętności',
        addProject: 'Udokumentuj swój pierwszy projekt',
        addEducation: 'Dodaj swoją edukację',
        addLanguage: 'Dodaj języki, którymi mówisz',
        createCv: 'Utwórz pierwszą wersję CV',
        addPhoto: 'Dodaj zdjęcie profilowe',
        makePublic: 'Upublicznij profil, aby móc go udostępniać',
      },
      quickActions: {
        editProfile: 'Edytuj profil',
        addExperience: 'Dodaj doświadczenie',
        newCv: 'Nowa wersja CV',
        viewPublic: 'Zobacz profil publiczny',
      },
    },
    ai: {
      optimizeDescription: {
        button: 'Optymalizuj z AI',
        success: 'Opis zoptymalizowany',
      },
      suggestResponsibilities: {
        button: 'Zasugeruj z AI',
        success: 'Dodano {count} obowiązków',
        needsRole: 'Najpierw podaj stanowisko',
      },
      suggestSkills: {
        title: 'Zasugeruj umiejętności dla stanowiska',
        button: 'Zasugeruj z AI',
        rolePlaceholder: 'np. Senior Backend Engineer',
        empty: 'Podaj stanowisko i kliknij Zasugeruj, aby otrzymać propozycje umiejętności — kliknij sugestię, aby ją dodać.',
      },
      gapAnalysis: {
        title: 'Analiza luk kompetencyjnych (AI)',
        subtitle: 'Sprawdź, jak Twój profil pasuje do docelowego stanowiska — mocne strony, luki i rekomendacje wygenerowane przez AI.',
        targetRolePlaceholder: 'np. Senior Backend Engineer',
        button: 'Analizuj',
        matchScore: 'Dopasowanie',
        strengths: 'Mocne strony',
        gaps: 'Luki',
        recommendations: 'Rekomendacje',
        empty: 'Podaj docelowe stanowisko i kliknij Analizuj.',
      },
      error: {
        accessDenied: 'Funkcje AI wymagają subskrypcji Pro lub Expert albo własnego klucza API OpenRouter w ustawieniach AI.',
      },
    },
  },
}
